<template>
<div class="background" v-show="value">
  <div class="main">
    <el-form label-position="top" label-width="80px">
      <div class="close-button" @click="hide"><i class="el-icon-close"></i></div>

      <el-form-item label="Title">

      <el-input v-model="title"></el-input>
      </el-form-item>

      <el-form-item label="Content">

      <el-input v-model="content" type="textarea" :rows="20"></el-input>
      </el-form-item>
    </el-form>

    <div class="tail">
      <el-button style="float:right;margin:10px" type="info" @click="hide">Close</el-button>
      <el-button style="float:right;margin:10px" type="success" @click="send">Send</el-button>
      <div style="clear:both"></div>
    </div>

  </div>
</div>
</template>

<script>
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'

export default {
  name: 'Contact',

  props: ['value'],

  data () {
    return {
      title: '',
      content: ''
    }
  },

  methods: {
    hide () {
      this.$emit('input', false)
    },

    post (url, p, cb1 = () => {}, cb2 = () => {}) {
      let parts = [new Blob([JSON.stringify(p)], { type: 'application/json' })]
      let fileToSend = new File(parts, 'front-config.json', {
        type: 'application/json'
      })

      let formData = new FormData()

      formData.append('par', fileToSend)

      axios({
        method: 'post',
        url,
        data: formData,
        config: {headers: {'Content-Type': 'multipart/form-data'}},
        withCredentials: true
      }).then(response => {
        cb1(response)
      }).catch(error => {
        cb2(error)
      })
    },

    send () {
      let v = this
      let user = v.$store.state.user

      let content = {
        user: user.username,
        email: user.email,
        content: v.content,
        title: v.title
      }

      v.post(v.$store.state.host + `/dokhlab/actions/ohm/contact`, content, response => {
        alert('Your message has been sent to us successfully. We will get in touch with you soon.')
        this.hide()
      }, error => {
        alert(error)
      })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/theme.scss";


.background {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.main {
  border-radius: 5px;
  background-color: white;
  width: 50%;
  padding: 20px;
}

.head {
  position: relative;
}

.close-button {
  position: absolute;
  right: 5px;
  top: 5px;
  bottom: 5px;
}

</style>

